export default {"src":"/_next/static/media/bell-solid.3188eb07.svg","height":17,"width":15};